import instance from './DefaultApi';

export default class DispatchReportService {
    ControllerName = 'DispatchReport';

    // get all data
    GetDispatchReport(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchReport`, tableRequest).then(res => res)
    }
    //get export for Dispatch report
    GetReportExportDispatch(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetReportExportDispatch`, tableRequest).then(res => res)
    }
    //To Print Dispatch detail
    GetDispatchToPrint(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchToPrint`, d).then(res => res)
    }

     GetMigoReport(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMigoReport`, d).then(res => res)
    }

    GetStockInReport(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetStockInReport`, d).then(res => res)
    }
    
     GetOBDJsonReport(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetOBDJsonReport`, d).then(res => res)
    }

      GetOBDJsonReportForCompletion(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetOBDJsonReportForCompletion`, d).then(res => res)
    }

    GetStocktoExcel(id){
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetExportForStock?ReferenceId=` + id).then(res => res)
    }

    GetBillTypeDDL(){
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'DispatchReport'}/GetBillType`).then(res => res)
    }
   PushOBD(payload) {
    return instance.post(
        `${process.env.REACT_APP_API_URL}Dispatch/CallOutboundDeliveryApi`,
        payload
    ).then(res => res)
}

MarkOBDCompleted(deliveryNo) {
    return instance.post(
        `${process.env.REACT_APP_API_URL}DispatchReport/MarkOBDCompleted`,
        { DeliveryNo: deliveryNo }
    ).then(res => res)
}
    // GetDispatchToPrint(d) {
    //     debugger
    //     return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchToPrint`, d).then(res => res)
    // }

     GetDispatchToPrintDetails(d) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDispatchToPrintDetails`, d).then(res => res)
    }

    
    GetStocktoExcelSummary(id){
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetExportForStockSummary?ReferenceId=` + id).then(res => res)
    }
}